//Limitless imports
import { getGraphQLClient, handleSecureAjaxError } from "../../../portal";
import { RECORD_USER_DOCUMENT_VERIFICATION } from "../onboarding-queries/UserOnboardingVerificationQueries";
export const recordUserDocumentVerification = (transactionId, callback) => {
  const graphQLClient = getGraphQLClient();
  graphQLClient.mutate({
    mutation: RECORD_USER_DOCUMENT_VERIFICATION,
    variables: {
      transactionId
    },
    fetchPolicy: "no-cache"
  }).then(result => {
    callback(result.data.recordUserDocumentVerification);
  }).catch(error => {
    handleSecureAjaxError(error, "UserDocumentVerification recordUserDocumentVerification");
    callback({
      hasError: true,
      error
    });
  });
};